import { getCarbonCreditsLogic } from "./CarbonCredits.logic";
import { saveListCarbonCredits, saveCountCarbonCredits } from "../Infrastructure/CarbonCredits.store";

export async function getCarbonCredits(params) {
  const { count, resources: carbonCreditsData } = await getCarbonCreditsLogic(params);
  saveListCarbonCredits(carbonCreditsData);
  saveCountCarbonCredits(count);
}